export default __webpack_public_path__ + "static/media/OCRB Regular.52c863c3.ttf";